import { VFC } from 'react'
import { UserIcon } from 'src/components/Image/UserIcon'
import { Counter } from 'src/models/Room'
import { fontWeightBold } from 'src/styles/font'
import { flexCenter } from 'src/styles/mixins'
import styled from 'styled-components'
import { MESSAGE_DATE_FORMAT } from './common'
import { Content } from './Content'
import {
  ContentContainer,
  MessageBottom,
  MessageDiv,
  Timestamp,
} from './styles'
import { MessageBaseProps } from './types'

export { CounterMessage }

type MinimumCounter = Pick<Counter, 'iconSrc' | 'companyName' | 'id'>

export type CounterMessageProps = MessageBaseProps & {
  sender: MinimumCounter
  onClickSender?: (sender: MinimumCounter) => void
}
const CounterMessageComponent: VFC<CounterMessageProps> = ({
  sender = null,
  message,
  setPreviewImage,
  className,
  onClickSender,
}) => {
  const { iconSrc, companyName } = sender || {}
  const onClick =
    onClickSender && sender ? () => onClickSender(sender) : undefined

  return (
    <MessageDiv className={className}>
      <UserIconDiv>
        <UserIcon onClick={onClick} src={iconSrc} size="40px" />
      </UserIconDiv>
      <div>
        <CompanyName onClick={onClick}>{companyName}</CompanyName>
        <ContentContainer>
          <Content
            content={message.content}
            deleted={message.deleted}
            setPreviewImage={setPreviewImage}
          />
        </ContentContainer>
      </div>
      <MessageBottom>
        <Timestamp>{message.sentAt.format(MESSAGE_DATE_FORMAT)}</Timestamp>
      </MessageBottom>
    </MessageDiv>
  )
}

const CounterMessage = styled(CounterMessageComponent)``

const CompanyName = styled.h4<{ onClick?: () => void }>`
  font-size: 14px;
  font-weight: ${fontWeightBold};
  ${({ onClick }) => onClick && 'cursor: pointer;'}
`
const UserIconDiv = styled.div`
  ${flexCenter}
`
